<template>
  <div id="wishSelected" class="page">
    <h1>Dein Geschenk für</h1>
    <div id="foto_container">
      <div id="foto">
        <img src="../assets/img/ben-2018.jpeg">
      </div>
      <div id="kidsname">
          <p>{{party.kidsname}}</p>
      </div>
    </div>  
    <div id="wishSelectedBox">
      <div class="columns">
        <div class="column">
          <h3>Klasse, du hast dich für ein Geschenk entschieden.</h3>
          
    <div id="wishlistbox">
      <ul v-if="party.wishes">
        <li v-for="(wish,key) in filteredWishes">
          <div class="wish">
            <div class="wish_image">
              <img v-if=" wish.image != ''" :src="wish.image">
            </div>
            <div class="wish_content">
              <p><strong>{{ wish.name }}</strong><br>
                  EUR {{ wish.price}}<br>&nbsp;<br>
                  <a v-if=" key == JSON.parse($cookie.get('party')).gift ">Euer Geschenk</a>
              </p>
              <div v-if="wish.url" class="shopnow">Du kannst das Geschenk jetzt hier kaufen:<br>
	              <a v-bind:href="wish.url" class="button" target="_blank"><img class="shoplogo" src="../assets/img/onlineshops/amazon.de-logo.svg"></a>
              </div>
              <div class="actions">
                <a v-on:click="chooseGift(key)" class="button" v-if=" key != JSON.parse($cookie.get('party')).gift && wish.taken === false ">auswählen</a>
                <a v-on:click="removeGift(key)" class="button" v-if=" key == JSON.parse($cookie.get('party')).gift ">Auswahl aufheben</a>
                </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
          
        </div>
      </div>
    </div>  
  </div>
</template>
<script>
import {db} from '../service/firebase';  
import { find } from 'lodash'

export default {
  name: 'WishSelected',
  components: {
    
  },
  firebase: {},
  data (){
    return {
      wish: {
        //wishes:[]
      },
    }
  },
  computed: {
    //self:this,
    filteredWishes : function() {
      var wish = { [this.$store.state.userfacts.gift] : this.party.wishes[this.$store.state.userfacts.gift]}
      return wish
/*
      return this.party.wishes.filter(function(item) {
        return item.key == this.$store.state.userfacts.gift ;
    })
*/
    }
  },
  methods: {
    removeGift(key){
        this.$store.state.userfacts.gift = false
        this.$cookie.set('party', JSON.stringify(this.$store.state.userfacts), 30); 
        var updates = {};
        updates['/parties/' + this.$store.state.currentParty + '/wishes/' + key  +'/taken' ] = false;      
        var ref =  db.ref().update(updates)
        this.$router.push('/wishlist' )
    },
    chooseGift(key) {

      this.$store.state.userfacts.gift = key;
      this.$cookie.set('party', JSON.stringify(this.$store.state.userfacts), 30); 
      
      if( this.$store.state.userfacts.kid ) {
          console.log('updating taken ' + key + " / " + this.$store.state.userfacts.kid);
          var updates = {};
          updates['/parties/' + this.$store.state.currentParty + '/wishes/' + key  +'/taken' ] = this.$store.state.userfacts.kid;
          var ref =  db.ref().update(updates)
          console.log(ref)
          this.$router.push('/wishlist/wish/selected' )
      } else {
        this.$router.push('/guests' )        
      }
    }
  },
  mounted() {
    //console.log( this.$store.state.currentParty )
  },
  created (){
   this.$bindAsObject('party', db.ref('parties/' + this.$store.state.currentParty ), null, function() { /* console.log('Ready fired!') */ } );
  },
}
</script>
<style>
  #wishSelected .actions { text-align: left; }
  .shopnow { display: block; padding: 1.433333em 0; color: #369fb4; text-align: left; border-radius: 5px; }
  .shopnow .button { min-width: 10em; text-align: center; }
</style>